import { DialogTitleProps as MUIDialogProps } from '@mui/material'

export type DialogTitleProps = MUIDialogProps & {
  hideCloseButton?: boolean
}
